import { render, staticRenderFns } from "./CustomAddressForm.vue?vue&type=template&id=4de9e2fa"
import script from "./CustomAddressForm.vue?vue&type=script&lang=js"
export * from "./CustomAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports